import { useCallback } from 'react';
import { useToggle, useLatest } from 'react-use';
import { useRebootActionMutation } from 'apis/cm';

function useRebootDevice(device, options) {
  const deviceRef = useLatest(device);
  const [open, toggleOpen] = useToggle(false);
  const mutation = useRebootActionMutation(options);
  const { mutate } = mutation;
  const reboot = useCallback(() => {
    toggleOpen(false);
    mutate(deviceRef.current);
  }, [deviceRef, toggleOpen, mutate]);

  return {
    mutation,
    trigger: {
      onClick: toggleOpen
    },
    dialog: {
      open,
      onCancel: toggleOpen,
      onConfirm: reboot
    }
  };
}

export default useRebootDevice;
